import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { PACKAGES } from "../data/content";

export const Pricing = () => (
  <section className="section section-alt" id="pricing" data-testid="pricing-section">
    <div className="wrap">
      <Reveal className="section-head">
        <span className="eyebrow"><span className="sq" /> Our Packages</span>
        <h2 data-testid="pricing-heading">Flexible engagement models, crafted for your goals.</h2>
        <p>Whichever stage you're at, there's a package built for it — or we'll build one for you.</p>
      </Reveal>
      <Reveal delay={80}>
        <div className="pricing-grid" data-testid="pricing-grid">
          {PACKAGES.map((p) => (
            <div
              className={`price-card ${p.featured ? "featured" : ""}`}
              key={p.name}
              data-testid={`price-card-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {p.featured && <span className="featured-badge">Flexible</span>}
              <h4>{p.name}</h4>
              <div className="desc">{p.desc}</div>
              <ul>
                {p.features.map((f) => (
                  <li key={f}><Check size={15} strokeWidth={3} /> {f}</li>
                ))}
              </ul>
              <div className="fit">{p.fit}</div>
            </div>
          ))}
        </div>
      </Reveal>
      <Reveal delay={140}>
        <p className="pricing-note" data-testid="pricing-custom-note">
          <strong>Need something custom?</strong> We create tailored solutions aligned with your goals,
          timeline, and budget. <a href="#contact" data-testid="pricing-custom-link">Let's talk about the
          perfect package for you →</a>
        </p>
      </Reveal>
    </div>
  </section>
);
